export default Object.freeze({
    OPEN: 'OPEN',
    OUT_OF_TIME: 'OUT_OF_TIME',
    ACCEPTED: 'ACCEPTED',
    DECLINED: 'DECLINED',
    CANCELED: 'CANCELED',
    DONE: 'DONE',
    DONE_BY_CRON: 'DONE_BY_CRON',
    UNAVAILABLE: 'UNAVAILABLE',
    NO_SHOW: 'NO_SHOW',
})
